Immutable = require 'seamless-immutable'
moment = require 'moment'
{
	BEGIN_OBSERVATION,
	CREATE_OBSERVATION,
	CREATE_OBSERVATION_CYCLE,
	CREATE_OBSERVATION_QUESTION_RESPONSES,
	CREATE_STUDENT_OBSERVATION,
	CREATE_STUDENT_OBSERVATION_EVENT,
	CREATE_TEACHER_OBSERVATION,
	CREATE_TEACHER_OBSERVATION_EVENT,
	END_OBSERVATION,
	END_OBSERVATION_CYCLE,
	END_STUDENT_OBSERVATION,
	END_STUDENT_OBSERVATIONS,
	END_TEACHER_OBSERVATION,
	FETCHED_OBSERVATIONS,
	FETCHED_RECENT_OBSERVATIONS,
	FETCHED_STUDENT_EVENT_TYPES,
	FETCHED_TEACHER_EVENT_TYPES,
	FETCHING_OBSERVATIONS,
	FETCHING_RECENT_OBSERVATIONS,
	FETCHING_STUDENT_EVENT_TYPES,
	FETCHING_TEACHER_EVENT_TYPES,
	PAUSE_STUDENT_OBSERVATIONS,
	PAUSE_TEACHER_OBSERVATION,
	REHYDRATE_OBSERVATION,
	SCORED_OBSERVATION,
	SCORING_OBSERVATION,
	UNPAUSE_STUDENT_OBSERVATIONS,
	UNPAUSE_TEACHER_OBSERVATION,
	UPDATED_OBSERVATION,
	UPDATING_OBSERVATION,
	UPLOADING_OBSERVATION,
	UPLOADED_OBSERVATION
} = require '../actions/observations'
{ doing, did } = require './common'


dehydrateObservation = (observation) ->
	localStorage.setItem('currentObservation', JSON.stringify(observation))

getRehydratedObservation = ->
	return JSON.parse(localStorage.getItem('currentObservation'))

endStudentObservation = (state, studentId) ->
	lastStudentObservation = null
	lastStudentObservationIndex = null

	state.current.student_observations.map (studentObservation, index) ->
		if studentObservation.student_id == studentId
			lastStudentObservationIndex = index
			lastStudentObservation = studentObservation

	if lastStudentObservation && !lastStudentObservation.ended_at
		state = state.setIn(
			['current', 'student_observations', lastStudentObservationIndex, 'ended_at'],
			moment.utc().format('YYYY-MM-DD HH:mm:ss')
		)

	dehydrateObservation(state.current)
	return state

endStudentObservations = (state) ->
	studentIds = state.current.student_observations.map (studentObservation) ->
		return studentObservation.student_id

	# For each unique student ID, end the most recent student observation
	studentIds = studentIds.map (studentId, index) ->
		state = endStudentObservation(state, studentId)

	dehydrateObservation(state.current)
	return state

createStudentObservation = (state, studentObservation) ->
	if state.current.student_observations
		state = endStudentObservation(state, studentObservation.student_id)

		state = state.setIn(
			['current', 'student_observations'],
			state
				.current
				.student_observations
				.concat([studentObservation])
		)
	else
		state = state.setIn(
			['current', 'student_observations'],
			[studentObservation]
		)

	dehydrateObservation(state.current)
	return state

endTeacherObservation = (state) ->
	lastTeacherObservation = _.last(state.current.teacher_observations)

	if (lastTeacherObservation && !lastTeacherObservation.ended_at)
		state = state.setIn(
			['current', 'teacher_observations', state.current.teacher_observations.length - 1, 'ended_at'],
			moment.utc().format('YYYY-MM-DD HH:mm:ss')
		)

	dehydrateObservation(state.current)
	return state


createTeacherObservation = (state, teacherObservation) ->
	if state.current.teacher_observations
		state = endTeacherObservation(state)

		state = state.setIn(
			['current', 'teacher_observations'],
			state
				.current
				.teacher_observations
				.concat([teacherObservation])
		)
	else
		state = state.setIn(
			['current', 'teacher_observations'],
			[teacherObservation]
		)

	dehydrateObservation(state.current)
	return state


baseState = Immutable {
	current: getRehydratedObservation()
	isFetching: false
	isFetchingEventTypes: false
	isObserving: false
	isScoring: false
	isUpdating: false
	isUploading: false
	list: []
	recent: []
	reliabilityScores: {}
	studentEventTypes: null
	teacherEventTypes: null
}

observations = (state = baseState, action) ->
	switch action.type
		when BEGIN_OBSERVATION
			state = state.set 'isObserving', true

		when END_OBSERVATION
			state = state.set 'isObserving', false

		when FETCHING_OBSERVATIONS
			state = doing('isFetching', state)

		when FETCHED_OBSERVATIONS
			state = state.set 'isFetching', false
			state = state.set 'list', Immutable(action.payload.list) unless action.payload.error

		when FETCHING_RECENT_OBSERVATIONS
			state = doing('isFetching', state)

		when FETCHED_RECENT_OBSERVATIONS
			state = state.set 'isFetching', false
			state = state.set 'recent', Immutable(action.payload.list) unless action.payload.error

		when FETCHING_STUDENT_EVENT_TYPES
			state = doing('isFetchingEventTypes', state)

		when FETCHED_STUDENT_EVENT_TYPES
			state = state.set('isFetchingEventTypes', false)
			state = state.set('studentEventTypes', action.payload.list) unless action.payload.error

		when FETCHING_TEACHER_EVENT_TYPES
			state = doing('isFetchingEventTypes', state)

		when FETCHED_TEACHER_EVENT_TYPES
			state = state.set('isFetchingEventTypes', false)
			state = state.set('teacherEventTypes', action.payload.list) unless action.payload.error

		when CREATE_OBSERVATION
			state = state.set('current', action.payload.observation)
			dehydrateObservation(state.current)

		when CREATE_OBSERVATION_CYCLE
			if state.current.observation_cycles
				state = state.setIn(
					['current', 'observation_cycles'],
					state
						.current
						.observation_cycles
						.concat([action.payload.observationCycle])
					)
			else
				state = state.setIn(['current', 'observation_cycles'], [action.payload.observationCycle])

			dehydrateObservation(state.current)

		when END_OBSERVATION_CYCLE
			state = state.setIn(
				['current', 'observation_cycles', state.current.observation_cycles.length - 1, 'ended_at'],
				moment.utc().format('YYYY-MM-DD HH:mm:ss')
			)

			state = state.setIn(['current', 'observation_cycles', state.current.observation_cycles.length - 1, 'done'], true)
			dehydrateObservation(state.current)

		when CREATE_OBSERVATION_QUESTION_RESPONSES
			state = state.setIn(['current', 'observation_question_responses'], action.payload.observationQuestionResponses)
			dehydrateObservation(state.current)

		when CREATE_STUDENT_OBSERVATION
			state = createStudentObservation(state, action.payload.studentObservation)

		when CREATE_STUDENT_OBSERVATION_EVENT
			studentId = action.payload.studentId

			# find the current student observation for this student
			currentStudentObservationIndex = null

			state.current.student_observations.map (studentObservation, index) =>
				if studentObservation.student_id == studentId
					currentStudentObservationIndex = index

			currentStudentObservation = state.current.student_observations[currentStudentObservationIndex]

			if (currentStudentObservation.student_observation_events)
				state = state.setIn(
					['current', 'student_observations', currentStudentObservationIndex, 'student_observation_events'],
					state
						.current
						.student_observations[currentStudentObservationIndex]
						.student_observation_events
						.concat([action.payload.studentObservationEvent])
				)
			else
				state = state.setIn(
					['current', 'student_observations', currentStudentObservationIndex, 'student_observation_events'],
					[action.payload.studentObservationEvent]
				)

			dehydrateObservation(state.current)

		when CREATE_TEACHER_OBSERVATION
			state = createTeacherObservation(state, action.payload.teacherObservation)

		when CREATE_TEACHER_OBSERVATION_EVENT
			currentTeacherObservationIndex = state.current.teacher_observations.length - 1
			currentTeacherObservation = state.current.teacher_observations[currentTeacherObservationIndex]

			if (currentTeacherObservation.teacher_observation_events)
				state = state.setIn(
					['current', 'teacher_observations', currentTeacherObservationIndex, 'teacher_observation_events'],
					state
						.current
						.teacher_observations[currentTeacherObservationIndex]
						.teacher_observation_events
						.concat([action.payload.teacherObservationEvent])
				)
			else
				state = state.setIn(
					['current', 'teacher_observations', currentTeacherObservationIndex, 'teacher_observation_events'],
					[action.payload.teacherObservationEvent]
				)

			dehydrateObservation(state.current)

		when END_STUDENT_OBSERVATION
			state = endStudentObservation(state, action.payload.studentId)

		when END_TEACHER_OBSERVATION, PAUSE_TEACHER_OBSERVATION
			state = endTeacherObservation(state)

		when END_STUDENT_OBSERVATIONS, PAUSE_STUDENT_OBSERVATIONS
			state = endStudentObservations(state)

		when REHYDRATE_OBSERVATION
			state = state.set('current', getRehydratedObservation())

		when UNPAUSE_STUDENT_OBSERVATIONS
			# Get the most recent student observation for each student
			studentIds = state.current.student_observations.map (studentObservation) ->
				return studentObservation.student_id

			# Loop through each student ID and create a new student observation that is identical to the last,
			# but with updated timer and started_at values
			studentIds = _.uniq(studentIds)

			studentIds.map (studentId) ->
				studentObservations = state.current.student_observations.filter (studentObservation) ->
					return studentObservation.student_id == studentId

				lastStudentObservation = _.last(studentObservations)
				newStudentObservation = lastStudentObservation.asMutable({ deep: true })
				newStudentObservation.created_at = moment.utc().format('YYYY-MM-DD HH:mm:ss')
				# To determine the time on the clock, we need the time on clock for the last student observation,
				# plus the duration of the last student observation
				lastObservationDuration = moment(lastStudentObservation.ended_at, 'YYYY-MM-DD HH:mm:ss')
					.diff(moment(lastStudentObservation.started_at, 'YYYY-MM-DD HH:mm:ss'), 'seconds')

				lastTimeOnClock = moment('1901-01-01 ' + lastStudentObservation.time_on_clock, 'YYYY-MM-DD HH:mm:ss')
				newStudentObservation.time_on_clock = lastTimeOnClock.add(lastObservationDuration, 'seconds').format('HH:mm:ss')
				newStudentObservation.ended_at = null
				newStudentObservation.student_observation_events = []
				state = createStudentObservation(state, newStudentObservation)

			dehydrateObservation(state.current)

		when UNPAUSE_TEACHER_OBSERVATION
			lastTeacherObservation = _.last(state.current.teacher_observations)
			newTeacherObservation = lastTeacherObservation.asMutable({ deep: true })
			newTeacherObservation.created_at = moment.utc().format('YYYY-MM-DD HH:mm:ss')
			# To determine the time on the clock, we need the time on clock for the last teacher observation,
			# plus the duration of the last teacher observation
			lastObservationDuration = moment(lastTeacherObservation.ended_at, 'YYYY-MM-DD HH:mm:ss')
				.diff(moment(lastTeacherObservation.started_at, 'YYYY-MM-DD HH:mm:ss'), 'seconds')

			lastTimeOnClock = moment('1901-01-01 ' + lastTeacherObservation.time_on_clock, 'YYYY-MM-DD HH:mm:ss')
			newTeacherObservation.time_on_clock = lastTimeOnClock.add(lastObservationDuration, 'seconds').format('HH:mm:ss')
			newTeacherObservation.ended_at = null
			newTeacherObservation.teacher_observation_events = []
			state = createTeacherObservation(state, newTeacherObservation)

			dehydrateObservation(state.current)

		when UPDATING_OBSERVATION
			state = doing('isUpdating', state)

		when UPDATED_OBSERVATION
			state = state.set 'isUpdating', false
			state = state.set 'list', Immutable(action.payload.list) unless action.payload.error

		when SCORING_OBSERVATION
			state = doing('isScoring', state)

		when SCORED_OBSERVATION
			state = state.set 'isScoring', false
			state = state.set 'reliabilityScores', Immutable(action.payload) unless (action.payload.error)

		when UPLOADING_OBSERVATION
			state = doing('isUploading', state)

		when UPLOADED_OBSERVATION
			state = state.set 'isUploading', false

			unless action.payload.error
				state = state.set('mostRecentObservationId', action.payload.observation_id)
				localStorage.removeItem('currentObservation')
	state

module.exports = observations



// WEBPACK FOOTER //
// ./frontend/olos/js/reducers/observations.coffee